// extracted by mini-css-extract-plugin
export default {"reactFlowContainer":"projectPage_reactFlowContainer__IAW+L","outerContainer":"projectPage_outerContainer__fDFQO"};